const ACCOUNT_SERVICE_KEY = 'accountService';

let accountService;

export function getAccountService($injector) {
  if (!accountService) {
    accountService =
      $injector.has(ACCOUNT_SERVICE_KEY) && $injector.get(ACCOUNT_SERVICE_KEY);
  }
  return accountService;
}

export function getUser($injector) {
  const account = getAccountService($injector);
  return account && account.get().user;
}

export function isLoggedIn($injector) {
  return !!getUser($injector);
}

export function getUserId($injector) {
  const user = getUser($injector);
  return user ? user.id : undefined;
}

export function getTeam($injector) {
  const user = getUser($injector);
  return user && user.team;
}
